import React from 'react';
import { Provider } from 'react-redux';
import { ToastProvider } from '@veneer/core';
import {
  AnalyticsProvider,
  FeatureFlagProvider
} from '@eu-data-act/react-euda-commons/dist/index';

import { DependencyManagerProvider } from '../contexts/dependencyManager';

import * as T from '../App/types';
import store from '../store';
import Page from '../router';

const RoutesComponent = () => {
  return (
    <ToastProvider
      newOnTop
      position="top"
    >
      <Page />
    </ToastProvider>
  );
};

const MemoizedRoutesComponent = React.memo(RoutesComponent);

const App: React.FC<T.AppPropsType> = () => {
  return (
    <AnalyticsProvider>
      <DependencyManagerProvider>
        <FeatureFlagProvider>
          <Provider store={store}>
            <MemoizedRoutesComponent />
          </Provider>
        </FeatureFlagProvider>
      </DependencyManagerProvider>
    </AnalyticsProvider>
  );
};

export default App;
